<div class="lbig-tooltip" [style.background-color]="color">
  <p>
    <!--<span>{{ data.insuredName }}</span>-->
    <span>TEST</span>
  </p>
</div>
